import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SuperAdminHomeFeatureKey } from './superadmin-home-feature-key';
import { SuperAdminHomeState } from './superadmin-home.state';

export const SuperAdminHomeFeatureSelector =
  createFeatureSelector<SuperAdminHomeState>(SuperAdminHomeFeatureKey);

// All Users
export const allCustomersSelector = createSelector(
  SuperAdminHomeFeatureSelector,
  (state) => {
    return state.allCustomers;
  }
);
// All Users
export const allActiveUsersSelector = createSelector(
  SuperAdminHomeFeatureSelector,
  (state) => {
    return state.allActiveUsers;
  }
);
// All Notification
export const allNotificationsSelector = createSelector(
  SuperAdminHomeFeatureSelector,
  (state) => {
    return state.notifications;
  }
);

// Delete Notification
export const markAsReadNotificationSelector = createSelector(
  SuperAdminHomeFeatureSelector,
  (state) => {
    return state.markAsReadNotification;
  }
);

/**
 * All Users Selector
 */
export const allCustomersSuccessSelector = createSelector(
  allCustomersSelector,
  (state) => {
    return state.data;
  }
);
export const allCustomersFailureSelector = createSelector(
  allCustomersSelector,
  (state) => {
    return state.failure;
  }
);
export const allCustomersLoadingSelector = createSelector(
  allCustomersSelector,
  (state) => {
    return state.loading;
  }
);
/**
 * All Active Users Selector
 */
export const allActiveUsersSuccessSelector = createSelector(
  allActiveUsersSelector,
  (state) => {
    return state.data;
  }
);
export const allActiveUsersFailureSelector = createSelector(
  allActiveUsersSelector,
  (state) => {
    return state.failure;
  }
);
export const allActiveUsersLoadingSelector = createSelector(
  allActiveUsersSelector,
  (state) => {
    return state.loading;
  }
);
/**
 * All Notifications Selector
 */
export const allNotificationsSuccessSelector = createSelector(
  allNotificationsSelector,
  (state) => {
    return state.data;
  }
);
export const allNotificationsFailureSelector = createSelector(
  allNotificationsSelector,
  (state) => {
    return state.failure;
  }
);
export const allNotificationsLoadingSelector = createSelector(
  allNotificationsSelector,
  (state) => {
    return state.loading;
  }
);

/**
 * Delete Notification
 */
export const markAsReadNotificationSuccessSelector = createSelector(
  markAsReadNotificationSelector,
  (state) => {
    return state.data;
  }
);
export const markAsReadNotificationFailureSelector = createSelector(
  markAsReadNotificationSelector,
  (state) => {
    return state.failure;
  }
);
export const markAsReadNotificationLoadingSelector = createSelector(
  markAsReadNotificationSelector,
  (state) => {
    return state.loading;
  }
);

/**
 * Delete Notification
 */
export const notificationsCountSelector = createSelector(
  SuperAdminHomeFeatureSelector,
  (state) => {
    return state.notificationsCount;
  }
);
export const notificationsCountSuccessSelector = createSelector(
  notificationsCountSelector,
  (state) => {
    return state.data;
  }
);
export const notificationsCountFailureSelector = createSelector(
  notificationsCountSelector,
  (state) => {
    return state.failure;
  }
);
export const notificationsCountLoadingSelector = createSelector(
  notificationsCountSelector,
  (state) => {
    return state.loading;
  }
);
